// extracted by mini-css-extract-plugin
export var banner = "_f9-0";
export var closeButton = "_f9-2";
export var greenCheckmark = "_f9-3";
export var hereLink = "_f9-4";
export var titleIcon = "_f9-1";